import { v4 as uuidv4 } from "uuid";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import { createImageBlock } from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/mediaBlockHelpers";
import { createPBlock } from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/textBlocksHelpers";
import {
  getMarginOptions,
  getPaddingOptions,
} from "@circle-react-shared/BuilderUI/utils/boxModelStyleHelpers";
import { getBorderRadiusOptions } from "@circle-react-shared/BuilderUI/utils/imgStyleHelpers";
import { getSizingOptions } from "@circle-react-shared/BuilderUI/utils/sizeStyleHelpers";
import { getFontWeightOptions } from "@circle-react-shared/BuilderUI/utils/textStyleHelpers";
import { defaultData as defaultImageData } from "@circle-react-shared/Emails/VisualEmailBuilder/Blocks/Content/ImgBlock/ImgBlockDefaultData";
import placeholderImage from "@circle-react-shared/Emails/VisualEmailBuilder/Blocks/Content/ImgBlock/img_preview_large.png";
import { defaultData as defaultP1Data } from "@circle-react-shared/Emails/VisualEmailBuilder/Blocks/Content/PBlock/P1BlockDefaultData";
import { defaultData as defaultP2Data } from "@circle-react-shared/Emails/VisualEmailBuilder/Blocks/Content/PBlock/P2BlockDefaultData";
import { defaultData as defaultP3Data } from "@circle-react-shared/Emails/VisualEmailBuilder/Blocks/Content/PBlock/P3BlockDefaultData";
import { defaultStyles } from "./defaultStyles";

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "ProductCard",
  props: {
    productImage: {
      prop: "children",
      type: "children",
      value: [
        createImageBlock({
          signedId: "",
          placeholder: placeholderImage,
          baseData: defaultImageData,
          styles: {
            sizing: getSizingOptions({
              defaultValue: {
                width: "100%",
                height: "220px",
                minWidth: "auto",
                minHeight: "auto",
                maxWidth: "100%",
                maxHeight: "auto",
              },
            }),
            margin: getMarginOptions({
              defaultValue: {
                marginTop: "0",
                marginBottom: "0",
                marginLeft: "0",
                marginRight: "0",
              },
            }),
            borderRadius: getBorderRadiusOptions({
              defaultValue: {
                border_left_top_radius: 16,
                border_left_bottom_radius: 16,
                border_right_top_radius: 16,
                border_right_bottom_radius: 16,
              },
            }),
          },
        }),
      ],
    },
    productNameVariant: {
      prop: "children",
      type: "children",
      value: [
        createPBlock({
          text: "Product Name",
          baseData: defaultP2Data,
          styles: {
            fontWeight: getFontWeightOptions("600"),
            margin: getMarginOptions({
              defaultValue: {
                marginTop: "0",
                marginBottom: "4",
                marginLeft: "0",
                marginRight: "0",
              },
            }),
          },
        }),
        createPBlock({
          text: "Variant",
          baseData: defaultP3Data,
          styles: {
            margin: getMarginOptions({
              defaultValue: {
                marginTop: "0",
                marginBottom: "0",
                marginLeft: "0",
                marginRight: "0",
              },
            }),
          },
        }),
      ],
    },
    productPrice: {
      prop: "children",
      type: "children",
      value: [
        createPBlock({
          text: "$0.00",
          baseData: defaultP1Data,
          styles: {
            fontWeight: getFontWeightOptions("600"),
            margin: getMarginOptions({
              defaultValue: {
                marginTop: "0",
                marginBottom: "0",
                marginLeft: "0",
                marginRight: "0",
              },
            }),
          },
        }),
      ],
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        padding: getPaddingOptions({
          defaultValue: defaultStyles.padding,
        }),
        margin: getMarginOptions({
          defaultValue: defaultStyles.margin,
        }),
      },
    },
  },
};
